import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";
import { fetchGet } from "../../api/fetch";
import SingleTree from "./SingleTree";
import { map } from "lodash";

const styles = {

};



const VMITree = withStyles(styles)((props) => {
    const {
        zoneSelected,
        setZoneSelected
    } = props;

    const [trees, setTrees] = React.useState([]);
    

    React.useEffect(() => {
        try {
            fetchCompaniesSectors();
        } catch (error) {

        }
        return () => {setTrees([])};
    }, [])

    const fetchCompaniesSectors = async () => {
        try {
            var res = await fetchGet(`vmi/companies/sectors`)
            setTrees(res)

        } catch (e) {
            console.log(e);
        }
    }
    
    return (
        <div>
            {map(trees, (tree) => (
                <div key={tree.id}>
                    <SingleTree
                        tree={tree}
                        setZoneSelected={setZoneSelected}
                        zoneSelected={zoneSelected}
                    />
                    <hr style={{width: "85%"}}/>
                </div>
            ))}
        </div>
    );

});

export default withRouter(VMITree);
